export default __webpack_public_path__ + "static/media/IMG-20230628-WA0040.73480a27.jpg";